import { Component, Input, OnInit } from '@angular/core';
import { SNAgendaAppointment } from 'src/app/models/snagendaappointment';

@Component({
  selector: 'app-agenda-appointment-row',
  templateUrl: './agenda-appointment-row.component.html',
  styleUrls: ['./agenda-appointment-row.component.scss']
})
export class AgendaAppointmentRowComponent implements OnInit {

  @Input() appointment: SNAgendaAppointment;
  @Input() show: string[] = [];

  constructor() { }

  ngOnInit(): void {
  }

  isShown(field: string): boolean {
    return this.show.includes(field);
  }
}
